<template>
  <v-card class="pa-6">
    <FormGroups
      ref="mainModal"
      :labelBtn="labelBtn"
      :dialog.sync="dialog"
      :selectedItem="selectedGroup"
    />
    <FormContributors
      ref="contributorsModal"
      :nameGroup="nameGroup"
      :dialog.sync="dialogContrib"
      :selectedItem="selectedGroupCont"
    />
    <BaseDataTable
      :headers="headerTable"
      :items="itemsGrupos"
      :loading="loading"
      :items-per-page="8"
      :paginate="true"
      :currentPage="currentPage"
      :lastPage="lastPage"
      @pageChange="fetchEmailGroups({ ...filter, page: $event })"
    >
      <template v-slot:top>
        <v-row class="ma-0 pa-0">
          <v-col cols="12" md="7" lg="7" class="d-flex align-center pa-0">
          </v-col>
          <v-col cols="12" md="5" lg="5" class="d-flex align-start pa-0">
            <v-btn
              height="55px"
              dark
              class="mr-2 elevation-0"
              color="#313a46"
              v-can:permission="'email-grupo#store'" 
              @click="openModal"
            >
              <v-icon small class="mr-3">mdi-plus-circle</v-icon>adicionar
            </v-btn>
            <MenuFilterSearchTable
              :placeholder="'Buscar por nome'"
              :textQuery="'nome'"
              :codQuery="'id'"
              @textValue="updateFilter($event)"
            />
          </v-col>
        </v-row>
      </template>

      <!-- ---------------- header ---------------- -->
      <template v-slot:header.nome="{ header }">
        <span>
          {{ header.text }}
          <MenuFilter
            :label="header.text"
            :query="header.value"
            localFilter="api"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          ></MenuFilter>
        </span>
      </template>

      <template v-slot:header.descricao="{ header }">
        <span>
          {{ header.text }}
          <MenuFilter
            :label="header.text"
            :query="header.value"
            localFilter="api"
            @texValue="updateFilter($event)"
            @clearable="updateFilter($event)"
          ></MenuFilter>
        </span>
      </template>

      <!-- ---------------- items ---------------- -->
      <template v-slot:item.action="{ item }">
        <v-tooltip v-can:permission="'email-grupo#update'" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="openModalAdd(item)">
              <v-icon :attrs="attrs" v-on="on" color="primary"
                >mdi-account-edit</v-icon
              >
            </v-btn>
          </template>
          Adicionar/Remover colaboradores
        </v-tooltip>
        <v-tooltip v-can:permission="'email-grupo#update'" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="openModalEdit(item)">
              <v-icon :attrs="attrs" v-on="on" color="warning"
                >mdi-pencil</v-icon
              >
            </v-btn>
          </template>
          Editar grupo
        </v-tooltip>
        <v-tooltip v-can:permission="'email-grupo#delete'" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="deleteEmailGroup(item)">
              <v-icon :attrs="attrs" v-on="on" color="error"
                >mdi-trash-can</v-icon
              >
            </v-btn>
          </template>
          Apagar grupo
        </v-tooltip>
      </template>
    </BaseDataTable>
  </v-card>
</template>
<script>
import toast from "@/commom/toast";
import BaseDataTable from "@/components/BaseDataTable.vue";
import MenuFilter from "@/components/MenuFilter.vue";
import MenuFilterSearchTable from "@/components/MenuFilterSearchTable.vue";
import GruposEmail from "@/services/http/rpa/GruposEmail.js";
import { permissions } from "@/store/permissionsStore";
import toTitle from "@/util/util";
import FormContributors from "./FormContributors.vue";
import FormGroups from "./FormGroups.vue";

export default {
  components: {
    MenuFilter,
    FormGroups,
    FormContributors,
    MenuFilterSearchTable,
    BaseDataTable,
  },
  data() {
    return {
      labelBtn: "",
      dialog: false,
      lastPage: 1,
      currentPage: 1,
      nameGroup: "",
      dialogContrib: false,
      selectedGroup: "",
      selectedGroupCont: "",
      search: "",
      itemsGrupos: [],
      filter: {},
      loading: false,
    };
  },

  watch: {
    filter(value) {
      this.fetchEmailGroups(value);
    },
  },

  computed: {
    headerTable() {
      const permissionUser = permissions();
      let headers = [
        {
          text: "Nome",
          align: "center",
          sortable: true,
          value: "nome",
          filterable: true,
        },
        {
          text: "Descrição",
          align: "center",
          value: "descricao",
          filterable: true,
        },
      ];

      if (permissionUser.getPermissions['email-grupo'].includes('delete', 'update')) {
        headers.push({ text: "Ações", align: "center", value: "action" },);
      }
      return headers;
    }
  },

  methods: {
    updateFilter(event) {
      this.filter = { ...this.filter, ...event };
    },

    openModal() {
      this.dialog = true;
      this.labelBtn = "Cadastrar";
      if (this.$refs.mainModal.$refs.formGroups)
        this.$refs.mainModal.$refs.formGroups.reset();
    },

    openModalAdd(item) {
      this.dialogContrib = true;
      this.nameGroup = item.nome;
      this.selectedGroupCont = item;
    },

    openModalEdit(item) {
      this.dialog = true;
      this.labelBtn = "Editar";
      this.selectedGroup = item;
    },

    async closeModal() {
      this.dialog = false;
      await this.fetchServices();
    },

    async fetchEmailGroups(filters) {
      try {
        this.loading = true;
        let { data } = await GruposEmail().show({ ...filters, per_page: 8 });

        this.lastPage = data.last_page;
        this.currentPage = data.current_page;
        this.itemsGrupos = data.data.map((index) => {
          index.descricao = index.descricao.replace(/\?+/g, "çõ");
          return {
            ...index,
            descricao: toTitle(index.descricao.toUpperCase()),
            nome: index.nome.toUpperCase(),
          };
        });

        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },

    async deleteEmailGroup(item) {
      this.$swal({
        title: `Deseja apagar o grupo ${item.nome}?`,
        text: "Isso não pode ser desfeito",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, apagar grupo",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          GruposEmail(item.id)
            .delete()
            .then(() => {
              toast("success", "Grupo removido");
              this.fetchEmailGroups(this.filter);
            })
            .catch((err) => {
              this.$swal(
                "Opa!",
                "Houve um erro ao apagar este grupo.",
                "error"
              );
            });
        }
      });
    },
  },

  async created() {
    await this.fetchEmailGroups();
  },
};
</script>
<style>
@import "../../../../assets/style/style.css";
</style>
